import { Injectable } from '@angular/core';

declare const gapi: any;
declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class DriveserviceService {

  private clientId = '827292123788-fjve4jhkrq9cbbqrieo126no6chkqvde.apps.googleusercontent.com';
  private appId = 'steam-sequencer-149805';
  private apiKey = 'AIzaSyA1jBjL4b3Z6wdH2j5poqex7rt6zuZ0Acg';
  private scope = 'https://www.googleapis.com/auth/drive.file';

  // private clientId = '583745350364-deqjv8hvm0244uv131k10c1hovhaeqn0.apps.googleusercontent.com';
  // private appId = 'cube-test-341015';
  // private apiKey = 'AIzaSyDNGVN-OEgP9TVgvJmdlbXqgucykmY7A0k';

  private oauthAccessToken = null;
  private pickerApiLoaded = false;
  private pickerCallback = null;

  private pickerGlobal = null;

  private oAuthResult = null;

  public open(callback): void {
    this.pickerCallback = callback;
    // gapi.load('auth2', {'callback': this.onAuthApiLoad.bind(this)});
    // gapi.client.load('oauth2', 'v2', {'callback': this.onAuthApiLoad.bind(this)});
    gapi.load('auth', {'callback': this.onAuthApiLoad.bind(this)});
    gapi.load('picker', {'callback': this.onPickerApiLoad.bind(this)});
  }

  private onAuthApiLoad(): void {
    console.log(this.scope);
    // console.log(gapi.client.oauth2.userinfo.get())
    gapi.auth.authorize({
      'client_id': this.clientId,
      'scope': this.scope,
      'immediate': false,
    }, this.handleAuthResult.bind(this));
  }

  private onPickerApiLoad(): void {
    this.pickerApiLoaded = true;
    // console.log('Picker Api Load');
    // this.createPicker();
  }

  private handleAuthResult(authResult): void {
    console.log(authResult);
    if (authResult && !authResult.error) {
      this.oauthAccessToken = authResult.access_token;
      console.log('Auth Result ');
      this.createPicker();
    }else if(authResult.error){
      console.log('Error ',authResult);
      this.pickerCallback(authResult);
    }
  }

  public closeModal(): void {
    console.log(this.pickerGlobal.isVisible())
    // this.pickerGlobal.setVisible(false);
  }

  private createPicker(): void {
    console.log('Creando Picker ')
    if (this.pickerApiLoaded && this.oauthAccessToken) {
      let view = new google.picker.View(google.picker.ViewId.DOCS);
      // Use DocsUploadView to upload documents to Google Drive.
      var uploadView = new google.picker.DocsUploadView();
      // var uploadView = new google.picker.DocsUploadView().setParent('1sVBXd4GXa_IaQKZSkvnDpR3Slq_OsFAL');
      
      let picker = new google.picker.PickerBuilder()
        // .enableFeature(google.picker.Feature.NAV_HIDDEN)
        // .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setAppId(this.appId)
        // .setMaxItems(1)
        .setOAuthToken(this.oauthAccessToken)
        .addView(view)
        .addView(uploadView)
        // .addView(new google.picker.DocsUploadView())
        // .setDeveloperKey(this.apiKey)
        .setCallback(this.pickerCallback)
        .build();
      picker.setVisible(true);
      this.pickerGlobal = picker;
    }
  }
}
